import { Typography } from './Typography';
import styles from './ValueBox.module.css';
export function ValueBox({ value }: { value: string | number }) {
  return (
    <div className={styles.box}>
      <Typography as="span">{value}</Typography>
    </div>
  );
}
